module.exports = __webpack_public_path__ + "assets/img/btn-download-google-play-2dc8b98b.png";